import React from "react";
import Svg from "react-inlinesvg";
import "./logo.scss";
import logo from "./logo.svg";

const Logo = () => {
  return (
    <a href="https://evo.ca" className="logo" tabIndex="2" rel="noopener">
      <Svg src={logo} />
    </a>
  );
};

export default Logo;
